import React, { Component } from "react";
import { observable, toJS, set, getObserverTree } from "mobx";
import { inject, observer } from "mobx-react";
import { withRouter, Link } from "react-router-dom";
import { findIndex } from "lodash";
import { addPointer, getMiddle, getDistance, removePointer, onPointer, destroyPointer } from "../utils/panzoom-utils";

@inject("store")
@observer
class Popup extends Component {
  @observable open = false;
  @observable cssTransform = "";

  @observable point = null;

  @observable imageTop = 0;
  @observable imageLeft = 0;
  @observable imageScale = 2;
  @observable scale = 2;

  /// DELETE WHEN DONE
  @observable x = 0;
  @observable y = 0;
  @observable focalX;
  @observable focalY;
  @observable startClientX;
  @observable startClientY;
  @observable startScale;
  @observable startDistance;
  @observable pointers = [];
  @observable isPanning = false;

  componentDidMount() {
    // delete when done
    this.open = this.props.show || false;
    onPointer("down", this.element, this.handleDown.bind(this));
    onPointer("move", this.element, this.handleMove.bind(this));
    onPointer("up", this.element, this.handleUp.bind(this));
  }

  // delete when done
  componentWillUnmount() {
    destroyPointer("down", this.element, this.handleDown.bind(this));
    destroyPointer("move", this.element, this.handleMove.bind(this));
    destroyPointer("up", this.element, this.handleUp.bind(this));
  }

  componentWillReceiveProps() {
    setTimeout(() => {
      const point = this.props.store.points.find(o => o.id == this.props.store.point);
      if (point) {
        // assign the selected point to state
        this.point = point;
        // grab the scale from the popup data
        this.scale = this.point.popup.scale;
      }
      this.translate();
    }, 50);
  }

  translate() {
    if (this.point) {
      // console.clear();
      // console.log('Offset {SCALE X Y} For Excel File')
      // console.table(`${this.scale}\t${Math.ceil(this.point.popup.offsetX + this.x)}\t${Math.ceil(this.point.popup.offsetY + this.y)}`)

      const popupVpElm = $(".map-popup--image");
      const popupViewportW = popupVpElm.width();
      const popupViewportH = popupVpElm.height();

      let x = -this.point.x * this.scale + popupViewportW / 2;
      let y = -this.point.y * this.scale + popupViewportH / 2;

      if (this.point.popup.offsetX) {
        x += this.point.popup.offsetX;
      }
      if (this.point.popup.offsetY) {
        y += this.point.popup.offsetY;
      }

      this.imageLeft = x + this.x;
      this.imageTop = y + this.y;
      this.imageScale = this.scale;
    }
  }

  handlePagination({ dir }) {
    const sorted = this.props.store.points.filter(o => o[this.props.store.layer] == 1).sort((a, b) => a.sort - b.sort);
    const pointIndex = findIndex(sorted, o => o.id == this.props.store.point);
    const pointId = sorted[`${dir == "next" ? pointIndex + 1 : pointIndex - 1}`]?.id;
    if (pointId) {
      this.props.history.push(`/${this.props.store.layer}/${pointId}/popup`);
    }
    const point = this.props.store.points.find(o => o.id == pointId);
    // ga("send", "event", "LB City", point.label, `Popup Pagination ${dir == "next" ? "Next" : "Previous"}`);
    dataLayer.push({
      'event': 'gaEvent',
      'eventCategory': 'LB City - ' + this.props.store.layer,
      'eventAction': `Popup Pagination ${dir == "next" ? "Next" : "Previous"}`,
      'eventLabel': point.label
    });
  }

  handlePrev = () => this.handlePagination({ dir: "prev" });
  handleNext = () => this.handlePagination({ dir: "next" });

  // delete when done
  handleDown = event => {
    addPointer(this.pointers, event);
    this.isPanning = true;
    event.preventDefault();
    event.stopPropagation();
    this.focalX = this.x;
    this.focalY = this.y;

    const point = getMiddle(this.pointers);
    this.startClientX = point.clientX;
    this.startClientY = point.clientY;
    this.startScale = this.scale;
    this.startDistance = getDistance(this.pointers);
  };
  // delete when done
  handleMove = event => {
    if (
      !this.isPanning ||
      this.focalX === undefined ||
      this.focalY === undefined ||
      this.startClientX === undefined ||
      this.startClientY === undefined
    )
      return;

    addPointer(this.pointers, event);
    const current = getMiddle(this.pointers);

    this.x = this.focalX + (current.clientX - this.startClientX);
    this.y = this.focalY + (current.clientY - this.startClientY);

    this.translate();
  };
  // delete when done
  handleUp = event => {
    removePointer(this.pointers, event);
    if (!this.isPanning) return;

    this.isPanning = false;
    this.focalX = this.focalY = this.startClientX = this.startClientY = undefined;
  };

  render() {
    const { popup } = this.props.store;
    let region = localStorage.getItem("zennerOrSensus");
    return (
      <>
        <div className={`map-popup ${popup ? "opened" : "closed"}`} ref={node => (this.popup = node)}>
          <div className="map-popup--title">
            <img src="/city/assets/modal-logos.png" />
            <Link
              to={`/${this.props.store.layer}/${this.props.store.point}`}
              onClick={() => {
                // ga("send", "event", "LB City", this.props.store.point, "Popup Closed");
                dataLayer.push({
                  'event': 'gaEvent',
                  'eventCategory': 'LB City - ' + this.props.store.layer,
                  'eventAction': "Popup Closed",
                  'eventLabel': this.props.store.point
                });
              }}
            >
              <i className="far fa-times"></i>
            </Link>
          </div>
          <div className={`map-popup--image ${!this.point?.popup.showMap ? "hidden" : ""}`} ref={node => (this.element = node)}>
            <div
              className={`map-bg map-overlay-popup ${this.props.store.layer ? `map-layer--${this.props.store.layer == "smart" && region == "Zenner" ? "smartz" :  this.props.store.layer }` : ""}`}
              style={{ top: this.imageTop, left: this.imageLeft, transform: `scale(${this.imageScale})` }}
            ></div>
          </div>
          <div className="map-popup-scollable">
            <div className="map-popup--body">
              <div className="map-popup--body--image">
              {this.point?.popup.url != null ? ( 
                <>
                  <a href={this.point?.popup.url} target="_blank">
                    <img src={`/city/assets/images/${this.point?.popup.img}?w=300&h=300`} width="300" alt="" />
                  </a>
                  <a className="btn btn-primary" href={this.point?.popup.url} target="_blank">
                    LEARN MORE
                  </a>
                </>
              ):(
                <>
                  <img src={`/city/assets/images/${this.point?.popup.img}?w=300&h=300`} width="300" alt="" />
                </>
              )}
              </div>
              <div className="map-popup--body--copy">
                <div className="map-popup--body--copy--title">{this.point?.label}</div>
                <strong className="mb-1">{this.point?.popup.title}</strong>
                <div>{this.point?.popup.desc}</div>
              </div>
            </div>
          </div>
          <div className="map-popup--footer">
            <button onClick={this.handlePrev}>
              <i className="far fa-chevron-left"></i> PREVIOUS
            </button>
            <button onClick={this.handleNext}>
              NEXT <i className="far fa-chevron-right"></i>
            </button>
          </div>
        </div>
        <div
          className={`map-popup-background ${popup ? "opened" : "closed"}`}
          onClick={() => {
            this.props.history.push(`/${this.props.store.layer}/${this.props.store.point}`);
            // ga("send", "event", "LB City", this.props.store.point, "Popup Closed");
            dataLayer.push({
              'event': 'gaEvent',
              'eventCategory': 'LB City - ' + this.props.store.layer,
              'eventAction': "Popup Closed",
              'eventLabel': this.props.store.point
            });
          }}
        ></div>
      </>
    );
  }
}

export default withRouter(Popup);
